/* Native Shopify form remains the purchase source of truth; Loop owns plan selection. */
(function () {
  'use strict';
  function boot() {
    var node = document.querySelector('[data-gg-purchase-config]');
    if (!node) return;
    var config;
    try { config = JSON.parse(node.textContent); } catch (e) { return; }
    var form = document.getElementById('gg-form-' + config.productId);
    if (!form || form.dataset.ggPurchaseBound) return;
    form.dataset.ggPurchaseBound = 'true';
    var variants = config.variants || [];
    var plans = [];
    (config.plans || []).forEach(function (g) { plans = plans.concat(g.selling_plans || []); });
    var money = new Intl.NumberFormat(config.locale || 'en-US', { style: 'currency', currency: config.currency || 'USD' });
    function text(el, value) { if (el && el.textContent !== value) el.textContent = value; }
    function price(cents) { return money.format(cents / 100); }
    function read() {
      var values = new FormData(form);
      var variant = variants.find(function (v) { return String(v.id) === String(values.get('id')); }) || variants[0];
      if (!variant) return null;
      var quantity = Math.min(99, Math.max(1, parseInt(values.get('quantity'), 10) || 1));
      var planId = String(values.get('selling_plan') || '');
      var allocation = (variant.selling_plan_allocations || []).find(function (a) { return String(a.selling_plan_id) === planId; });
      var plan = plans.find(function (p) { return String(p.id) === planId; });
      var validPlan = !planId || !!allocation;
      var unitPrice = allocation ? allocation.price : variant.price;
      return { productId: config.productId, variant: variant, quantity: quantity, sellingPlanId: planId || null,
        plan: plan || null, validPlan: validPlan, unitPrice: unitPrice, totalPrice: unitPrice * quantity,
        available: !!variant.available, purchasable: !!variant.available && validPlan };
    }
    var lastSignature = '';
    function render() {
      var state = read();
      if (!state) return;
      var label = !state.available ? 'Out of stock' : !state.validPlan ? 'Choose a purchase option' : 'Add to cart';
      var cadence = state.plan ? state.plan.name : 'One-time purchase';
      var selection = state.variant.title + ' · Qty ' + state.quantity + ' · ' + cadence;
      if (!state.validPlan) selection = 'Choose a purchase option for this size.';
      var main = form.querySelector('[data-gg-atc]');
      var content = main && main.querySelector('.gg-buybox__atc-default');
      if (content) text(content, label + (state.purchasable ? ' — ' + price(state.totalPrice) : ''));
      else if (main && !main.classList.contains('is-loading')) text(main, label + (state.purchasable ? ' — ' + price(state.totalPrice) : ''));
      var sticky = document.getElementById('gg-sticky-btn-' + config.productId);
      var final = document.querySelector('.gg-finalcta__btn');
      [main, sticky, final].forEach(function (button) {
        if (!button) return;
        var disabled = !state.purchasable || !!(main && main.dataset.busy === '1');
        if (button.disabled !== disabled) button.disabled = disabled;
        if (button.getAttribute('aria-disabled') !== String(disabled)) button.setAttribute('aria-disabled', String(disabled));
      });
      text(sticky, label);
      text(document.querySelector('[data-gg-finalcta-label]'), label);
      text(document.querySelector('.gg-buybox__price'), price(state.unitPrice));
      var compare = document.querySelector('.gg-buybox__compare');
      var comparePrice = state.plan ? state.variant.price : state.variant.compare_at_price;
      if (compare) {
        var showCompare = comparePrice > state.unitPrice;
        compare.hidden = !showCompare;
        compare.style.display = showCompare ? 'inline' : 'none';
        if (showCompare) text(compare, price(comparePrice));
      }
      text(document.getElementById('gg-sticky-price-' + config.productId), price(state.totalPrice));
      text(document.getElementById('gg-sticky-size-' + config.productId), state.variant.title + (state.quantity > 1 ? ' × ' + state.quantity : '') + ' · ');
      text(document.querySelector('[data-gg-sticky-plan]'), cadence);
      text(document.querySelector('[data-gg-finalcta-price]'), price(state.totalPrice));
      text(document.querySelector('[data-gg-finalcta-selection]'), selection);
      text(form.querySelector('[data-gg-purchase-summary]'), selection);
      var express = form.querySelector('[data-gg-express]');
      if (express) express.hidden = !state.purchasable;
      var signature = JSON.stringify([state.variant.id, state.quantity, state.sellingPlanId, state.unitPrice, state.available, state.validPlan]);
      if (signature !== lastSignature) {
        lastSignature = signature;
        document.dispatchEvent(new CustomEvent('gg:purchase-change', { detail: state }));
      }
    }
    var frame = null;
    function schedule() {
      if (frame !== null) return;
      frame = requestAnimationFrame(function () { frame = null; render(); });
    }
    var quantityInput = form.querySelector('[name="quantity"]');
    function quantity(delta) {
      if (!quantityInput) return;
      quantityInput.value = Math.min(99, Math.max(1, (parseInt(quantityInput.value, 10) || 1) + delta));
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
    var minus = form.querySelector('[data-gg-qty-minus]');
    var plus = form.querySelector('[data-gg-qty-plus]');
    if (minus) minus.addEventListener('click', function () { quantity(-1); });
    if (plus) plus.addEventListener('click', function () { quantity(1); });
    if (quantityInput) quantityInput.addEventListener('change', function () { quantity(0); });
    form.addEventListener('input', schedule);
    document.addEventListener('change', schedule);
    document.addEventListener('variant:change', schedule);
    document.addEventListener('click', function (e) {
      if (e.target.closest('.loop-widget-container')) { schedule(); setTimeout(schedule, 350); }
    });
    new MutationObserver(schedule).observe(form, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'disabled'] });
    // Some Loop versions change a hidden input's value property without an event.
    var timer = setInterval(function () { if (!document.hidden) render(); }, 500);
    window.addEventListener('pagehide', function () { clearInterval(timer); });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      var button = form.querySelector('[data-gg-atc]');
      if (button) { delete button.dataset.busy; button.classList.remove('is-loading'); }
      clearInterval(timer);
      timer = setInterval(function () { if (!document.hidden) render(); }, 500);
      render();
    });
    form.addEventListener('submit', function (e) {
      var state = read();
      var button = form.querySelector('[data-gg-atc]');
      if (!state || !state.purchasable || (button && button.dataset.busy === '1')) {
        e.preventDefault();
        render();
        return;
      }
      if (button) { button.dataset.busy = '1'; button.classList.add('is-loading'); }
    });
    window.GGPurchaseState = { productId: config.productId, getState: read, refresh: schedule };
    render();

    // ByteStand owns the estimate, its automatic lookup, ZIP submission and errors.
    // Keep its native controls live; this layer supplies labels and failure context.
    var chip = document.querySelector('[data-bytestand-chip]');
    if (chip) {
      var body = chip.querySelector('.gg-shipchip__body');
      var fallback = chip.querySelector('[data-gg-delivery-fallback]');
      function delivery() {
        var input = chip.querySelector('#zipCode');
        var apply = chip.querySelector('#applyButton');
        if (input && !input.hasAttribute('aria-label')) input.setAttribute('aria-label', 'Delivery ZIP or postal code');
        if (input && !input.hasAttribute('autocomplete')) input.setAttribute('autocomplete', 'postal-code');
        if (apply && apply.type !== 'button') apply.type = 'button';
        var date = chip.querySelector('#deliveryBy');
        var app = chip.querySelector('#bytestand-app-block');
        var good = date && date.textContent.trim().length > 3 && getComputedStyle(date).display !== 'none' && app && getComputedStyle(app).display !== 'none';
        if (fallback) fallback.hidden = !!good;
        var warning = chip.querySelector('#serviceWarning');
        if (fallback && warning && getComputedStyle(warning).display !== 'none') {
          text(fallback, 'An estimate is unavailable right now. Your delivery options and timing will be shown at checkout.');
          fallback.hidden = false;
        }
      }
      document.addEventListener('gg:delivery-status', function (e) {
        delivery();
        if (fallback && e.detail && e.detail.state === 'failed') {
          text(fallback, 'An estimate is unavailable right now. Your delivery options and timing will be shown at checkout.');
          fallback.hidden = false;
        }
      });
      if (body) new MutationObserver(delivery).observe(body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['style', 'hidden'] });
      delivery();
      setTimeout(function () {
        if (fallback && !fallback.hidden) text(fallback, 'Enter or update your ZIP code for an estimate. If a date is unavailable, check delivery options at checkout.');
      }, 10000);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
